import { clsx } from 'clsx';
import { cloneElement, type TouchEventHandler, type JSX } from 'react';
import styles from './Carousel.module.scss';

type CarouselSlidesProps = {
  disableAnimation?: boolean;
  enableLoop?: boolean;
  selectedSlide: number;
  slides: JSX.Element[];
  isPdp?: boolean;
  touchEvents: {
    onTouchStart: TouchEventHandler<HTMLDivElement>;
    onTouchMove: TouchEventHandler<HTMLDivElement>;
    onTouchEnd: TouchEventHandler<HTMLDivElement>;
  };
};

export const CarouselSlides = ({
  disableAnimation = false,
  enableLoop = true,
  selectedSlide,
  slides,
  isPdp = false,
  touchEvents
}: CarouselSlidesProps) => (
  <div
    className={`${styles.slides} ${isPdp ? styles.pdpCarousel : ''}`}
    role="group"
    aria-label="Carousel Slides"
    {...touchEvents}>
    {slides.map((slide, index) =>
      cloneElement(slide, {
        ...slide.props,
        style: {
          ...(selectedSlide > index ||
          (enableLoop && index === 0 && selectedSlide === slides.length - 1)
            ? { transform: `translateX(${(index - selectedSlide) * 100}%)` }
            : {}),
          ...(selectedSlide < index ||
          (enableLoop && index === slides.length - 1 && selectedSlide === 0)
            ? { transform: `translateX(${(index - selectedSlide) * 100}%)` }
            : {})
        },
        className: clsx(
          styles.slide,
          selectedSlide === index && styles.selected,
          disableAnimation && selectedSlide !== index && styles.hide
        ),
        key: slide.key,
        'data-selected': selectedSlide === index ? 'true' : 'false',
        'data-slide-index': index
      })
    )}
  </div>
);
